{
  "ru": {
    "roamingDevices": {
      "title": "Совместимые устройста",
      "warning": "Устройства, произведенные до 2018 года, не будут совместимы с eSIM",
      "choose-brand": "Выберите производителя",
      "close": "Закрыть"
    }
  },
  "kk": {
    "roamingDevices": {
      "title": "eSIM жарайтын құрылғылар",
      "warning": "2018 жылға дейін шыққан құрылғыларда eSIM функциясы болмайды",
      "choose-brand": "Брендті таңдаңыз",
      "close": "Жабу"
    }
  },
  "en": {
    "roamingDevices": {
      "title": "Compatible devices",
      "warning": "Devices produced before 2018 will not be compatible with eSIM",
      "choose-brand": "Select the brand",
      "close": "Close"
    }
  }
}
